export default function subMenu(element, data) {
    const allSubMenuChilds = element.querySelectorAll('.header__submenu_item.has-grand-child');
    const allGrandChilds = element.querySelectorAll('.header__submenu_child_items');

    if (!element.querySelector('.header__submenu_item.has-grand-child.active')) {
        const firstItem = allSubMenuChilds[0];

        if (firstItem) {
            const childId = firstItem.dataset.id;
            const grandChilds = element.querySelectorAll(`.header__submenu_child_items[data-id="${childId}"]`);

            firstItem.classList.add('active');
            grandChilds.forEach(el => el.classList.add('active'));
        }
    }

    element.addEventListener('mouseover', function(event) {
        const sbChild = event.target.closest('.header__submenu_item.has-grand-child');

        if (!sbChild || sbChild.classList.contains('active')) return;

        const childId = sbChild.dataset.id;
        const grandChilds = element.querySelectorAll(`.header__submenu_child_items[data-id="${childId}"]`);

        allGrandChilds.forEach(el => el.classList.remove('active'));
        allSubMenuChilds.forEach(el => el.classList.remove('active'));

        sbChild.classList.add('active');
        grandChilds.forEach(grandChild => grandChild.classList.add('active'));
    });
};